import { LoginRegistration } from "@/src/homepage/login/full-page-login-registration";
import { MobileWebView } from "@/src/mobile/MobileWebView";

import { Blog } from "./blog";
import { BrandDetails } from "./brand-details";
import { BrowserNotSupported } from "./browser-not-supported";
import { CashbackLandingPage } from "./cashback-landing-page";
import { CashbackLandingPageMobile } from "./cashback-landing-page-mobile";
import { CashbackMainPage } from "./cashback-main-page";
import { DiscountDetails } from "./discount-details";
import { DiscountLandingPage } from "./discount-landing-page";
import { EmailConfirmationPage } from "./email-confirmation-page";
import { FavoritesTab } from "./favorites-tab";
import { FlyerDetails } from "./flyer-details";
import { FlyersTab } from "./flyers-tab";
import { FollowedBrandsTab } from "./followed-brands-tab";
import { GenerateOnetUrl } from "./generate-onet-url";
import { GenericError } from "./generic-error";
import { Homepage } from "./homepage";
import { LandingPageLoyaltyCard } from "./landing-page-loyalty-card";
import { LoyaltyProgramsList } from "./loyalty-programs-list";
import { MgmLandingPage } from "./mgm-landing-page";
import { MgmLoginAndRegistrationPage } from "./mgm-login-and-registration-page";
import { MgmMainPage } from "./mgm-main-page";
import { MgmOff } from "./mgm-off";
import { MgmPhoneVerification } from "./mgm-phone-verification";
import { MgmRedeemCodePage } from "./mgm-redeem-code-page";
import { MomentDetails } from "./moment-details";
import { MomentMap } from "./moment-map";
import { Newsletter } from "./newsletter";
import { NotFound } from "./not-found";
import { Offers } from "./offers";
import { OnetExternal } from "./onet-external";
import { RedirectPage } from "./redirect-page";
import { Search } from "./search";
import { SettingsHandler } from "./settings-handler";
import { ShoppingMallDetails } from "./shopping-mall-details";
import { ShoppingMallsFilters } from "./shopping-malls-filters";
import { ShoppingMallsList } from "./shopping-malls-list";
import { ShoppingMallsTab } from "./shopping-malls-tab";
import { SitemapIndex } from "./sitemap-index";
import { StampLoyaltyCard } from "./stamp-loyalty-card";
import { TemporaryTrxListPage } from "./temporary-trx-list-page";
import { Unauthorized } from "./unauthorized";
import { Voucher } from "./voucher";

export default {
    GenerateOnetUrl,
    Blog,
    BrandDetails,
    FollowedBrandsTab,
    BrowserNotSupported,
    CashbackLandingPage,
    CashbackLandingPageMobile,
    TemporaryTrxListPage,
    CashbackMainPage,
    EmailConfirmationPage,
    DiscountDetails,
    DiscountLandingPage,
    FlyerDetails,
    GenericError,
    NotFound,
    Unauthorized,
    FavoritesTab,
    FlyersTab,
    Homepage,
    LandingPageLoyaltyCard,
    LoyaltyProgramsList,
    StampLoyaltyCard,
    MgmLandingPage,
    MgmLoginAndRegistrationPage,
    MgmMainPage,
    MgmOff,
    MgmPhoneVerification,
    MgmRedeemCodePage,
    MobileWebView,
    MomentDetails,
    MomentMap,
    Newsletter,
    Offers,
    RedirectPage,
    SitemapIndex,
    Search,
    SettingsHandler,
    ShoppingMallDetails,
    ShoppingMallsFilters,
    ShoppingMallsList,
    ShoppingMallsTab,
    Voucher,
    LoginRegistration,
    OnetExternal,
};
